import React, { useMemo } from 'react';

import { FilterBadgeProps } from '../../../../../helpers/filterBadges/types';
import {
  FetchCategoriesScopes,
  FetchCategoriesSortTypes
} from '../../../../categories/categoriesTypes';

import { CACHE_FETCH_CATEGORIES_SELECT_FIELD_QUERY } from '../../../../categories/queries/fetchCacheCategoriesSelectField.query';
import {
  FETCH_CATEGORIES_SELECT_FIELD_QUERY,
  FetchCategoriesSelectFieldQueryResponse
} from '../../../../categories/queries/fetchCategoriesSelectField.query';

import { useFinPaginatedCategories } from '../../../../categories/hooks/useFinPaginatedCategories';

import { ItemsFilterBadge } from '../../../../../helpers/filterBadges/ItemsFilterBadge';

import { CategoryCache } from '../../../../categories/CategoryCache';

import {
  CategoriesPermissions,
  productCategoriesScopes
} from '../../../../categories/categoriesConstants';

import { categoriesKeys } from '../../../../../locales/keys';

const scope = FetchCategoriesScopes.FACILITIES_RENDER_TYPES;

const options = {
  staleTime: 1000 * 60 * 60,
  withoutPrefetch: true
};

interface ProductsRenderTypesFilterBadgeItem {
  id: string;
  label: string;
}

function ProductsRenderTypesFilterBadge({
  filters,
  name,
  onRemoveFilter
}: FilterBadgeProps) {
  const productCategoriesAction = productCategoriesScopes.includes(scope)
    ? CategoriesPermissions.READ_PRODUCT_CATEGORIES_INDEX_ES_QUERY
    : undefined;

  const { categories } =
    useFinPaginatedCategories<FetchCategoriesSelectFieldQueryResponse>({
      action: productCategoriesAction,
      cacheKey: CategoryCache.categoriesSelectFieldCacheKey(scope),
      query: FETCH_CATEGORIES_SELECT_FIELD_QUERY,
      cacheQuery: CACHE_FETCH_CATEGORIES_SELECT_FIELD_QUERY,
      initialFilters: { scope: { eq: scope } },
      initialSort: [FetchCategoriesSortTypes.LOCALIZED_NAME_ASC],
      initialLimit: 1000,
      options
    });

  const badgeItems = useMemo<ProductsRenderTypesFilterBadgeItem[]>(() => {
    return categories.map((category) => ({
      id: category.id as string,
      label: category.localizedName
    }));
  }, [categories]);

  return (
    <ItemsFilterBadge
      dataGa="products-type-filter-badge-clear"
      filters={filters}
      i18nLabel={categoriesKeys.renderTypes.plural}
      items={badgeItems}
      name={name}
      onRemoveFilter={onRemoveFilter}
    />
  );
}

export default ProductsRenderTypesFilterBadge;
